<input type="checkbox" value="{{params.value}}">